<template>
  <q-form ref="form" class="full-width q-pa-md">
    <div class="row items-center">
      <div class="col-12 q-px-sm">
        <q-input
          v-model="formData.name"
          label="Trailer Name"
          :rules="[v => !!v || 'Name is Required']"
        ></q-input>
      </div>
      <div class="col-12 q-px-sm">
        <q-input
          v-model="formData.rego"
          label="Registration"
          :rules="[v => !!v || 'Registration is Required']"
        ></q-input>
      </div>
    </div>
  </q-form>
</template>

<script>
export default {
  components: {},
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  watch: {
    data: function() {
      this.init();
    }
  },
  data: () => ({
    // Extra Data
    formData: {}
  }),
  mounted() {
    setTimeout(() => {
      this.init();
    }, 100);
  },
  methods: {
    init() {
      if (this.data != null) {
        this.formData = JSON.parse(JSON.stringify(this.data));
      } else {
        this.formData = {};
      }
    },
    create() {
      this.$emit("loadingStateChanged", true);
      setTimeout(() => {
        this.$refs.form.validate().then(result => {
          if (result) {
            this.$store.dispatch("newTrailer", this.formData).then(result => {
              this.$emit("loadingStateChanged", false);
              if (result.Result == "Success") {
                this.$emit("close", true);
                this.formData = {};
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: result.Response.Message
                });
              }
            });
          } else {
            this.$emit("loadingStateChanged", false);
          }
        });
      }, 200);
    },
    save() {
      this.$emit("loadingStateChanged", true);
      setTimeout(() => {
        this.$store.dispatch("saveTrailer", this.formData).then(result => {
          this.$emit("loadingStateChanged", false);
          if (result.Result == "Success") {
            this.address = "";
            this.$emit("close", true);
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: "Trailer has been saved"
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
        });
      });
    }
  }
};
</script>
